module.exports = __webpack_public_path__ + "static/img/jdy1.4fc0603.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jdy1.png
// module id = QPuA
// module chunks = 0